import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Arrow = styled.span`
  &:after{
    color: ${props => props.theme.secondaryColor};
    margin-right: 4px;
    font: ${props => props.theme.fontWeightBold} 22px/100% ${props => props.theme.fontFamilyBody};
  }
`;

const Left = styled(Arrow)`
  &:after{
    content: "<";
  }
`;

const Right = styled(Arrow)`
  &:after {
    content: ">";
  }
`;

const Center = styled.span`
  &:after {
    content: "|";
    margin: 0 4px;
    color: ${props => props.theme.columnChartGridColor};
    font: ${props => props.theme.fontWeightMedium} 16px/100% ${props => props.theme.fontFamilyBody};
  }
`;

const Button = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme.secondaryColor};
  text-transform: uppercase;
  outline: none;
  font: ${props => props.theme.fontWeightMedium} 12px/120% ${props => props.theme.fontFamilyBody};
  display: flex;
  align-items: center;

  &:hover {
    ${props => props.enabled && `
      text-decoration: underline;
      color: ${props.theme.primaryColor};
    `};
  }

  ${props => !props.enabled && `
    color: ${props.theme.columnChartGridColor};
    cursor: default;
  `};
`;

const Container = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const G2Names = {
  d: 'days',
  w: 'weeks',
  m: 'months',
};

export default function ColumnChartNav({
  range, visibleRange, granularity, onPrev, onNext,
}) {
  if (range.start - range.end <= visibleRange.start - visibleRange.end) {
    return null;
  }

  const prev = {
    type: 'button',
    enabled: range.start > visibleRange.start,
    onClick: e => {
      e && e.preventDefault();
      (range.start > visibleRange.start) && onPrev();
    },
  };

  const next = {
    type: 'button',
    enabled: range.end < visibleRange.end,
    onClick: e => {
      e && e.preventDefault();
      (range.end < visibleRange.end) && onNext();
    },
  };

  return (
    <Container>
      <Left />
      <Button {...prev}>{`previous 30 ${G2Names[granularity]}`}</Button>
      <Center />
      <Button {...next}>{`next 30 ${G2Names[granularity]}`}</Button>
      <Right />
    </Container>
  );
}

const rangeShape = {
  start: PropTypes.number.isRequired,
  end: PropTypes.number.isRequired,
};

ColumnChartNav.propTypes = {
  range: PropTypes.shape(rangeShape).isRequired,
  visibleRange: PropTypes.shape(rangeShape).isRequired,
  granularity: PropTypes.oneOf(['d', 'w', 'm']).isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};
